import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b47ea9c0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47ea9c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b47ea9c0')) {
      api.createRecord('b47ea9c0', component.options)
    } else {
      api.reload('b47ea9c0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b47ea9c0&scoped=true", function () {
      api.rerender('b47ea9c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cameraDialog/index.vue"
export default component.exports